import { render } from "./PreApp.vue?vue&type=template&id=29615d2a"
import script from "./PreApp.vue?vue&type=script&lang=js"
export * from "./PreApp.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__